/**
 * Visit Context
 * get User Tasks to be displayed in visit top bar if any
 */
export const getUserTasks = (
  tasks: mumms.PatientCppTask[] | null,
  user: mumms.User,
) => {
  const { userRoleGroups } = user;
  if (tasks && tasks.length) {
    const userTasks = tasks?.reduce(
      (seed: mumms.PatientCppTask[], task: mumms.PatientCppTask) => {
        if (userRoleGroups && userRoleGroups.length) {
          if (task.who && userRoleGroups.includes(task.who)) {
            seed.push(task);
            return seed;
          }
        }
        return seed;
      },
      [],
    );
    return userTasks.length ? userTasks : null;
  }
  return null;
};
